import React, { useState, useEffect } from 'react';

export const StepFinish = (props) => {

    const { email } = props

    return <div className="m-form__step m-form__step--confirm">
        <div className="m-form__container">
            <div className="m-form__icon"></div>
            <h2 className="m-form__header">Aby potwierdzić złożenie wniosku kliknij w link, który wysłaliśmy na adres e-mail</h2>
            <p className="m-form__content">{email}</p>
        </div>
    </div>
}

